<div class="dialog" [class.mobile]="rwdService.isSmallDevice">
  <app-dialog-header [showCloseButton]="false">
    <ng-container custom-data>
      <span class="dialog-header">
        <div class="dialog-header-text">
          <h1>{{ 'label.summary' | loc }}</h1>
          <div>{{ 'label.checkForm' | loc }}</div>
        </div>
        <button mat-icon-button class="close-icon" [mat-dialog-close]="false" type="button">
          <mat-icon inline>close</mat-icon>
        </button>
      </span>
    </ng-container>
  </app-dialog-header>
  <mat-dialog-content>
    <ng-content></ng-content>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button class="mat-primary" [mat-dialog-close]="false">{{ 'button.returnToEdit' | loc }}</button>
    <button mat-raised-button class="mat-primary mat-elevation-z0" [mat-dialog-close]="true">
      {{ 'button.save' | loc }}
    </button>
  </mat-dialog-actions>
</div>
